export const iPhone17Models = [
  { id: 'iphone17', name: 'iPhone 17', basePrice: 999 },
  { id: 'iphone17-plus', name: 'iPhone 17 Plus', basePrice: 1099 },
  { id: 'iphone17-pro', name: 'iPhone 17 Pro', basePrice: 1199 },
  { id: 'iphone17-pro-max', name: 'iPhone 17 Pro Max', basePrice: 1299 },
];

export const storageOptions = [
  { id: '128gb', name: '128GB', price: 0 },
  { id: '256gb', name: '256GB', price: 100 },
  { id: '512gb', name: '512GB', price: 300 },
  { id: '1tb', name: '1TB', price: 500 },
];

export const colorOptions = [
  { id: 'natural-titanium', name: 'Natural Titanium', hex: '#8E8E93' },
  { id: 'blue-titanium', name: 'Blue Titanium', hex: '#1E3A8A' },
  { id: 'white-titanium', name: 'White Titanium', hex: '#F8F9FA' },
  { id: 'black-titanium', name: 'Black Titanium', hex: '#1C1C1E' },
];

export const nigerianStates = [
  'Abia',
  'Adamawa',
  'Akwa Ibom',
  'Anambra',
  'Bauchi',
  'Bayelsa',
  'Benue',
  'Borno',
  'Cross River',
  'Delta',
  'Ebonyi',
  'Edo',
  'Ekiti',
  'Enugu',
  'FCT',
  'Gombe',
  'Imo',
  'Jigawa',
  'Kaduna',
  'Kano',
  'Katsina',
  'Kebbi',
  'Kogi',
  'Kwara',
  'Lagos',
  'Nasarawa',
  'Niger',
  'Ogun',
  'Ondo',
  'Osun',
  'Oyo',
  'Plateau',
  'Rivers',
  'Sokoto',
  'Taraba',
  'Yobe',
  'Zamfara',
];
